/**
 * Avalara © 2017
 * file: engines/opus_ui/src/redux/configure_store.js
 */

import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware, createStore } from 'redux';
import logger from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';

export default function configureStore(history) {
  const routingMiddleware = routerMiddleware(history);
  const middleware = [routingMiddleware, thunk];
  if (!window.__REDUX_DEVTOOLS_EXTENSION__) {
    middleware.push(logger);
  }
  const composeEnhancers = composeWithDevTools({});

  // Note: passing middleware as the last argument requires redux@>=3.1.0
  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middleware))
  );

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}
